import { Injectable, inject } from '@angular/core';
import { ToastService } from '@idealink-material/ui-utils';

@Injectable({
    providedIn: 'root'
})
export class MsgService {
    private readonly toastService = inject(ToastService);

    info(title: string, msg: string) {
        this.toastService.info(msg, { title });
    }

    warning(title: string, msg: string) {
        this.toastService.warning(msg, { title });
    }

    error(title: string, msg: string) {
        this.toastService.error(msg, { title });
    }

    success(title: string, msg: string) {
        this.toastService.success(msg, { title });
    }
}
